import { createFileRoute } from '@tanstack/react-router';
import { GenericPageHeader } from '@/components/layout/page-header';
import { Button } from '@/components/ui/button';
import { BookingAppearanceSettings, type SaveState } from '@/pages/bookings/BookingAppearanceSettings';
import { useCallback, useState } from 'react';
import { useLingui } from '@lingui/react/macro';
import { useSetTitle } from '@/stores/title-context';

function CustomizePage() {
	const { t } = useLingui();
	useSetTitle(t`Customize`);
	const [saveState, setSaveState] = useState<SaveState | null>(null);

	const handleSaveStateChange = useCallback((state: SaveState) => {
		setSaveState(state);
	}, []);

	return (
		<div className="flex flex-col h-full">
			<GenericPageHeader
				title={t`Customization`}
				actions={
					saveState && (
						<Button
							onClick={saveState.onSave}
							disabled={!saveState.isDirty || saveState.isPending || !saveState.hasServices}
						>
							{saveState.isPending ? t`Saving...` : t`Save changes`}
						</Button>
					)
				}
			/>
			<div className="flex-1 overflow-y-auto">
				<div className="p-4">
					<BookingAppearanceSettings onSaveStateChange={handleSaveStateChange} />
				</div>
			</div>
		</div>
	);
}

export const Route = createFileRoute('/_authenticated/_app/bookings/customize')({
	component: CustomizePage,
});
